import { ProviderType } from '@/types/models'

export const MAX_BUDGET_PACING = 10001
export const MATCH_SPECIALIZATION_BOOST = 15000
export const QUALITY_REDUCE_RATIO = 0.2
export const RANDOM_DEFLATE_RATIO = 0.0001
export const LOCAL_SPONSOR_BOOST = 1800
export const MIN_BROWSE_BOOST = 10000
export const MATCHED_BROWSE_TREATS_BOOST_CAP = 20000
export const BROWSE_BOOST_PER_TERM = 2500
export const FOCUS_BOOST = 30
export const NON_FOCUS_PENALTY = 0
export const MATCHED_EATING_DISORDERS_BOOST = 10000
export const MATCHED_MENTAL_HEALTH_BOOST = 90
export const MATCHED_BEHAVIORAL_ADDICTION_BOOST = 30
export const RESIDENTIAL_PROVIDER_BOOST = 20
export const FREE_CENTER_MATCHES_PRIMARY_AND_SPECIALIZATION_THRESHOLD =
  FOCUS_BOOST

export const DEFAULT_WEIGHTS = {
  MATCH_SPECIALIZATION_BOOST,
  QUALITY_REDUCE_RATIO,
  LOCAL_SPONSOR_BOOST,
  MIN_BROWSE_BOOST,
  MATCHED_BROWSE_TREATS_BOOST_CAP,
  BROWSE_BOOST_PER_TERM,
  FOCUS_BOOST,
  NON_FOCUS_PENALTY,
  MATCHED_EATING_DISORDERS_BOOST,
  MATCHED_MENTAL_HEALTH_BOOST,
  MATCHED_BEHAVIORAL_ADDICTION_BOOST,
  RESIDENTIAL_PROVIDER_BOOST
}

export const PROVIDER_TYPES_TO_BOOST = [
  ProviderType.DETOX,
  ProviderType.INTERVENTIONIST,
  ProviderType.RECOVERY_COACH,
  ProviderType.SOBER,
  ProviderType.LIVING,
  ProviderType.RETREAT,
  ProviderType.VIRTUAL,
  ProviderType.IN_HOME,
  ProviderType.SOBER_LIVING
]

export const FACETS_TO_BOOST = [
  'what_we_treat',
  'treatment_methods',
  'amenities',
  'special_considerations',
  'treatment_therapies',
  'who_we_treat'
]

export const DEWEIGHTED_SPECIALIZATION_BOOST = 400

export const DEWEIGHTED_SPECIALIZATIONS = []
